module.exports = __webpack_public_path__ + "static/media/slide_three.5c5fa62d.jpg";